// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__f2JRa","removeArea":"styles_removeArea__VZzLP","text":"styles_text__+sBIN"};